// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.search-question[data-v-e90d4a84]{padding:1.2rem 1.6rem;border-radius:2rem;background-color:#f2f2f5;max-width:450px;justify-self:flex-end;font-size:1.8rem;line-height:2.4rem;font-weight:400;font-family:\"SuisseIntl\",arial,sans-serif,\"Space\";letter-spacing:.02rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
